import { useState, useEffect } from "react";

import {
  Grid,
  Divider,
  Typography,
  Icon,
  IconButton,
  Link,
} from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import CustomDataGrid from "components/CustomDataGrid";
import { useParams } from "react-router-dom";
import axios from "utils/axios";
import { normalizeData } from "utils/utils";

import { CheckCircle, Cancel } from "@mui/icons-material";
const OkIcon = () => <CheckCircle color="success" />;
const CancelIcon = () => <Cancel color="error" />;

export default function CompFields({
  register,
  control,
  errors,
  getValues,
  setError,
  setValue,
  watch,
}) {
  const fields = [
    {
      label: "Name",
      name: "name",
      required: true,
      type: "text",
    },
  ];

  const params = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        "/api/categories/" + params.id + "?populate=*"
      );
      const norm = normalizeData(data);
      console.log(norm);
      setCategory(norm);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Grid container spacing={2} rowSpacing={4} justifyContent="space-between">
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            fieldVariants="outlined"
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            defaultValue={watch(field.name)}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
      <Grid container item xs={12} rowSpacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" align="center">
            Businesses
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <CustomDataGrid
            columns={[
              {
                field: "name",
                headerName: "Name",
                flex: 1,
                minWidth: 10,
              },
              {
                field: "address",
                headerName: "Address",
                flex: 1,
                minWidth: 10,
              },
              {
                field: "emails",
                headerName: "Emails",
                flex: 1,
                minWidth: 10,
                maxWidth: 100,
                renderCell: function render(params) {
                  return (
                    <Grid container justifyContent="center">
                      {params.row.emails ? <OkIcon /> : <CancelIcon />}
                    </Grid>
                  );
                },
              },
              {
                field: "website",
                headerName: "Website",
                flex: 1,
                minWidth: 10,
                maxWidth: 100,
                renderCell: function render(params) {
                  return (
                    <Grid container justifyContent="center">
                      {params.row.website ? (
                        <Link
                          href={params.row.website}
                          target="_blank"
                          rel="noopener"
                        >
                          <IconButton
                            sx={{
                              width: 32,
                              height: 32,
                            }}
                          >
                            <Icon>open_in_new</Icon>
                          </IconButton>
                        </Link>
                      ) : (
                        <Icon>cancel</Icon>
                      )}
                    </Grid>
                  );
                },
              },
              {
                field: "actions",
                headerName: "Actions",
                flex: 1,
                minWidth: 10,
                maxWidth: 100,
                renderCell: function render(params) {
                  return (
                    <Grid container justifyContent="center">
                      <Link
                        href={`/businesses/edit/${params.row.id}`}
                        target="_self"
                        rel="noopener"
                      >
                        <IconButton
                          onClick={() => {
                            window.open(
                              `/businesses/edit/${params.row.id}`,
                              "_self"
                            );
                          }}
                          sx={{
                            width: 32,
                            height: 32,
                          }}
                        >
                          <Icon>visibility</Icon>
                        </IconButton>
                      </Link>
                    </Grid>
                  );
                },
              },
            ]}
            data={category ? category.businesses : []}
            loading={loading}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
